module.exports = __webpack_public_path__ + "Roboto-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Regular.ttf
// module id = 97
// module chunks = 0